import { seoContent } from '@/mocks/seoData';

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-14">
          <p className="text-xs font-semibold text-primary-500 uppercase tracking-widest mb-3">
            Simple Process
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            {seoContent.stepsTitle}
          </h2>
          <p className="text-sm text-foreground-500">
            {seoContent.stepsSubtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {seoContent.steps.map((step, index) => (
            <div key={step.number} className="relative p-6 md:p-8 rounded-xl bg-secondary-100 border border-secondary-200/60">
              <div className="flex items-start justify-between mb-5">
                <span className="font-heading text-5xl md:text-6xl font-bold text-secondary-300 leading-none">
                  {step.number}
                </span>
                <div className="w-9 h-9 rounded-full bg-background-50 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line text-foreground-500"></i>
                </div>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                {step.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {step.description}
              </p>
              {/* Connector line between steps */}
              {index < 2 && (
                <div className="hidden md:block absolute -right-3 top-1/2 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-2xl text-secondary-300"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}